import React, { useRef, useState } from "react";
import { Box, Button, Modal, Typography, Stack } from "@mui/material";
import { convertTo12HourTimeCompact } from "../../../util/general/convertTo12HourTimeCompact";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100vw",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflowY: "auto",
  height: "80%",
};

export default function PrintModal(props) {
  const [open, setOpen] = useState(true);
  const printRef = useRef();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    props.closeModal();
  };
  const usdFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const handlePrint = () => {
    if (printRef.current) {
      const printContents = printRef.current.innerHTML;
      const newWindow = window.open("", "_blank");
      console.log(printContents);
      newWindow.document.write(`
        <html>
          <head>
            <title>Booking Confirmation</title>
          </head>
          <body>${printContents}</body>
        </html>
      `);
      newWindow.document.close();
      newWindow.print();
    }
  };

  const handleSendSMS = () => {};

  return (
    <div>
      <Modal open={open} onClose={handleClose} aria-labelledby="modal-title">
        <Box sx={style}>
          <div ref={printRef}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                // alignItems: "center",
                width: "100vw",
                fontSize: "18px",
                marginLeft: "15px",
              }}
            >
              <div
                style={{
                  fontWeight: "600",
                  fontSize: "26px",
                  marginLeft: "40px",
                  marginBottom: "10px",
                  textAlign: "center",
                }}
              >
                {props.data.bookingDetail.celebrant}'s Party
              </div>
              <div style={{ fontSize: "26px" }}></div>
              <div
                style={{
                  display: "flex",
                  // justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ textAlign: "center", paddingLeft: "50px" }}>
                  Booking#: {props.data._id.slice(-6)} {""}
                </div>
                <div style={{ textAlign: "center", paddingLeft: "30px" }}>
                  Deposit Date:{" "}
                  {props.data.non_refund_deposite_date.slice(5, 10)}-
                  {props.data.non_refund_deposite_date.slice(0, 4)}
                </div>
                <div style={{ textAlign: "center", paddingLeft: "30px" }}>
                  Deposit receipt:{" "}
                  {props.data.deposit_receipt ? props.data.deposit_receipt : ""}
                </div>
              </div>

              <div style={{ fontWeight: "600", marginBottom: "10px" }}>
                Contact:
              </div>
              <div style={{ marginLeft: "20px", marginBottom: "25px" }}>
                <Box style={{}}>{props.data.bookingDetail.guardian_name}</Box>
                <Box style={{}}>{props.data.bookingDetail.phone_number}</Box>
                <Box style={{}}>{props.data.bookingDetail.email}</Box>
              </div>

              <div
                style={{
                  fontWeight: "600",
                  marginBottom: "10px",
                }}
              >
                Birthday boy/girl:
              </div>
              <div style={{ marginBottom: "25px", marginLeft: "20px" }}>
                <div style={{}}>
                  {props.data.bookingDetail.celebrant} (
                  {props.data.bookingDetail.gender})
                </div>
                <div style={{}}>Age: {props.data.bookingDetail.age}</div>
              </div>

              <div
                style={{
                  fontWeight: "600",
                  marginBottom: "10px",
                }}
              >
                Guest:
              </div>
              <div style={{ marginBottom: "25px", marginLeft: "20px" }}>
                <div style={{}}>
                  Childrens: {props.data.bookingDetail.num_kid}
                </div>
                <div style={{}}>
                  Adults: {props.data.bookingDetail.num_adult}
                </div>
              </div>
              <div style={{ fontWeight: "600", marginBottom: "10px" }}>
                Party:
              </div>
              <div style={{ marginBottom: "20px", marginLeft: "20px" }}>
                <div style={{}}>
                  Date: {props.data.bookingDetail.party_date.slice(5, 10)}-
                  {props.data.bookingDetail.party_date.slice(0, 4)}
                </div>
                <div style={{}}>
                  Time:{" "}
                  {convertTo12HourTimeCompact(
                    props.data.bookingDetail.party_time
                  )}
                </div>
              </div>
              <div style={{ marginBottom: "20px", marginLeft: "20px" }}>
                <Box style={{}}>{props.data.package.package_name}</Box>
                <Box style={{}}>Theme: {props.data.bookingDetail.theme}</Box>
              </div>
              <div style={{ marginBottom: "20px", marginLeft: "20px" }}>
                <Box style={{}}>
                  Gummy Dragon:{" "}
                  {props.data.bookingDetail.upgrade_gummy_dragon ? "Yes" : "No"}
                </Box>
                <Box style={{}}>
                  Luxury Package:{" "}
                  {props.data.bookingDetail.upgrade_luxury_package
                    ? "Yes"
                    : "No"}
                </Box>
                <Box style={{}}>
                  Unlimited Play Time:{" "}
                  {props.data.bookingDetail.upgrade_unlimited_playtime
                    ? "Yes"
                    : "No"}
                </Box>{" "}
                <Box style={{}}>
                  Outside food and drinks:{" "}
                  {props.data.bookingDetail.bring_own_food ? "Yes" : "No"}
                </Box>
              </div>
              <div style={{ marginBottom: "40px", marginLeft: "20px" }}>
                <div>Pizza</div>
                <Box style={{}}>
                  Cheese: {props.data.bookingDetail.cheese_pizza}
                </Box>
                <Box style={{}}>
                  Pepperoni: {props.data.bookingDetail.pepperoni_pizza}
                </Box>
                <Box style={{}}>
                  Veggie: {props.data.bookingDetail.veggie_pizza}
                </Box>
              </div>
              <div style={{ marginBottom: "40px", marginLeft: "20px" }}>
                <div style={{ marginBottom: "20px" }}>
                  {props.data.bookingDetail.special_request}
                </div>
                <div>
                  Total: {usdFormatter.format(props.data.total_cost)} (after
                  discount, tax not included)
                </div>
                <div>
                  Non-Refundable Deposite: -
                  {usdFormatter.format(props.data.non_refund_deposite)}
                </div>
                <div>
                  10% Service Fee: +
                  {usdFormatter.format(props.data.total_cost * 0.1)}
                </div>
                <div>
                  Estimated Balance:{" "}
                  {usdFormatter.format(
                    props.data.total_cost * 1 -
                      props.data.non_refund_deposite * 1 +
                      props.data.total_cost * 0.1
                  )}{" "}
                  (after discount, tax not included)
                </div>
              </div>
              <div style={{ fontWeight: "600" }}>
                Booking staff: {props.data.bookingDetail.assigned_employee}
              </div>
              <div style={{ fontWeight: "600" }}>
                Assigned staff: {props.data.bookingDetail.serve_party_employee}
              </div>
            </div>
          </div>
          <div style={{ textAlign: "right", mt: 2, mb: 2, paddingBottom: 2 }}>
            {/* <Button onClick={handleSendSMS}>Send Confirmation SMS</Button> */}
            <Button
              variant="outlined"
              sx={{ mt: 2, mr: 2 }}
              onClick={handleClose}
            >
              Close
            </Button>
            <Button
              variant="outlined"
              sx={{ mt: 2, mr: 2 }}
              onClick={handlePrint}
            >
              Print
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
